import { ConnectedAccountResponseDto } from '@helios/frontend-api-v2-client';
import { Button, ModalV3, useTranslation } from '@helios/frontend-core';

import { Icon } from '@palmetto/palmetto-components';
import { useEffect } from 'react';
import { useDeleteConnectedAccount } from '../../../api/connected-accounts/useConnectedAccounts';

interface ArcadiaRemoveConfirmationModalProps {
  isOpen: boolean;
  onDismiss: () => void;
  account: ConnectedAccountResponseDto;
  parentTrackingId: string;
}

const TRACKING_ID = 'arcadia-connected-account';

export const ArcadiaRemoveConfirmationModal = (props: ArcadiaRemoveConfirmationModalProps) => {
  const { isOpen, onDismiss, account, parentTrackingId } = props;
  const { t } = useTranslation();
  const { mutate: deleteAccount, isLoading: isDeleting, isSuccess: isDeleteSuccess } = useDeleteConnectedAccount();

  useEffect(() => {
    if (isDeleteSuccess) {
      onDismiss();
    }
  }, [isDeleteSuccess, onDismiss]);

  return (
    <ModalV3 open={isOpen} onClose={onDismiss} trackingId={`${parentTrackingId}-${TRACKING_ID}-remove-confirmation`}>
      <div className="flex flex-row items-center self-start gap-8">
        <Icon name="c-remove" size="lg" className="text-text-error" />
        <h2 className="label-400 text-text-error">{t('connectedAccounts.removeUtilityConnection')}</h2>
      </div>
      <p className="body-400 text-text-error mt-12">
        {t('connectedAccounts.removeConfirmationDescription', {
          utilityName: account.utilityProvider?.name ?? t('connectedAccounts.yourUtility'),
        })}
      </p>
      <div className="flex flex-col gap-12 w-full mt-40">
        <Button
          trackingId={`${parentTrackingId}-${TRACKING_ID}-confirm-remove`}
          onClick={() => deleteAccount(account._id)}
          loading={isDeleting}
        >
          {t('connectedAccounts.removeConnection')}
        </Button>
        <Button emphasis="secondary" trackingId={`${parentTrackingId}-${TRACKING_ID}-nevermind`} onClick={onDismiss}>
          {t('connectedAccounts.nevermind')}
        </Button>
      </div>
    </ModalV3>
  );
};
